import {
  AdminAssessmentFilterStatus,
  AdminAssessmentFlaggedFilter,
  AdminAssessmentScoreBand,
  AdminHtsSubmissionFilterStatus,
  HTS_READINESS_BAND_THRESHOLDS,
} from '@evaltick/shared';

export interface ResultsFilterOption<T extends string> {
  value: T;
  label: string;
}

// Labels mirror what each table's Status/Score columns render, so a
// filtered row always shows the state it was filtered by.
export const ASSESSMENT_STATUS_OPTIONS: ResultsFilterOption<AdminAssessmentFilterStatus>[] = [
  { value: AdminAssessmentFilterStatus.InProgress, label: 'In Progress' },
  { value: AdminAssessmentFilterStatus.Completed, label: 'Completed' },
];

export const ASSESSMENT_FLAGGED_OPTIONS: ResultsFilterOption<AdminAssessmentFlaggedFilter>[] = [
  { value: AdminAssessmentFlaggedFilter.Yes, label: 'Flagged' },
  { value: AdminAssessmentFlaggedFilter.No, label: 'Not flagged' },
];

export const ASSESSMENT_SCORE_BAND_OPTIONS: ResultsFilterOption<AdminAssessmentScoreBand>[] = [
  { value: AdminAssessmentScoreBand.Strength, label: 'Strength' },
  { value: AdminAssessmentScoreBand.Developing, label: 'Developing' },
  { value: AdminAssessmentScoreBand.NeedsFocus, label: 'Needs Focus' },
];

export const HTS_SUBMISSION_STATUS_OPTIONS: ResultsFilterOption<AdminHtsSubmissionFilterStatus>[] = [
  { value: AdminHtsSubmissionFilterStatus.NeedsReview, label: 'Needs review' },
  { value: AdminHtsSubmissionFilterStatus.Released, label: 'Released' },
  { value: AdminHtsSubmissionFilterStatus.NoReviewNeeded, label: 'No review needed' },
];

// Same thresholds/labels the Score/Readiness columns use (bandLabelFor), so a
// filtered row always shows the band it was filtered by. Feeds both the Score
// and Readiness filters on the HTS tab — they're the same underlying value,
// shown as two controls so each sits under its matching column.
export const HTS_READINESS_BAND_OPTIONS = HTS_READINESS_BAND_THRESHOLDS.map((threshold) => ({
  value: threshold.band,
  label: threshold.label,
}));
